/**
 * Каналы push на Android (ROADMAP приложения, A6): уведомления разложены
 * по каналам, и человек отключает или делает беззвучным каждый в системных
 * настройках телефона — не трогая остальные.
 *
 * Канал выбирает сервер (render.PUSH_CHANNELS в apps/api) по категории
 * уведомления; приложение создаёт каналы с теми же id. Совпадение таблиц
 * проверяет push.test.ts.
 */

import { NotificationCategory } from "@taskflow/contracts";

export interface PushChannel {
  id: string;
  name: string;
  description: string;
  categories: readonly NotificationCategory[];
  /** Важные — со звуком и всплывающим окном; прочие — тихо, в шторку. */
  important: boolean;
}

export const PUSH_CHANNELS: readonly PushChannel[] = [
  {
    id: "assignments",
    name: "Назначения",
    description: "Вас назначили исполнителем или сняли с задачи",
    categories: [NotificationCategory.ASSIGNED, NotificationCategory.UNASSIGNED],
    important: true,
  },
  {
    id: "comments",
    name: "Комментарии и упоминания",
    description: "Новые комментарии в ваших задачах и упоминания",
    categories: [NotificationCategory.COMMENT, NotificationCategory.MENTIONED],
    important: true,
  },
  {
    id: "deadlines",
    name: "Сроки",
    description: "Истёк срок задачи",
    categories: [NotificationCategory.OVERDUE],
    important: true,
  },
  {
    id: "changes",
    name: "Изменения задач",
    description: "Статус, поля, файлы, подзадачи, закрытие и восстановление, наблюдение",
    categories: [
      NotificationCategory.STATUS_CHANGED,
      NotificationCategory.FIELDS_CHANGED,
      NotificationCategory.ATTACHMENT,
      NotificationCategory.SUBTASK,
      NotificationCategory.ARCHIVED,
      NotificationCategory.RESTORED,
      NotificationCategory.TASK_CREATED,
      NotificationCategory.TASK_DELETED,
    ],
    important: false,
  },
  {
    id: "access",
    name: "Доступ",
    description: "Вам открыли доску или пригласили в заметку",
    categories: [NotificationCategory.BOARD_INVITE, NotificationCategory.NOTE_INVITE],
    important: false,
  },
  {
    id: "reminders",
    name: "Напоминания",
    description: "Напоминания по задачам и из заметок",
    categories: [NotificationCategory.TASK_REMINDER, NotificationCategory.NOTE_REMINDER],
    important: true,
  },
  {
    id: "vacations",
    name: "Отпуска",
    description: "Скоро отпуск, пересечения и изменения отпуска",
    categories: [
      NotificationCategory.VACATION_UPCOMING,
      NotificationCategory.VACATION_CONFLICT,
      NotificationCategory.VACATION_CHANGED,
    ],
    important: false,
  },
];

export function pushChannelOf(category: NotificationCategory): string {
  return PUSH_CHANNELS.find((channel) => channel.categories.includes(category))?.id ?? "changes";
}
